<div class="page-container no-scroll">
    <app-header title="surveys.index.title">
        <div class="buttons">
            <ui-button *permission="createPermission" [routerLink]="['/surveys/center/create']" type="primary">
                <mat-icon svgIcon="plus" aria-hidden="true"></mat-icon>
                <span>{{ 'surveys.addSurvey' | appTranslate }}</span>
            </ui-button>
        </div>
    </app-header>

    <ui-card class="scrollable-table-container" [withMargin]="false" [withSpacing]="false">
        <app-table [table]="table" [isResponsive]="true" [showOffset]="true" [noPadding]="true" [embedded]="true">
            <app-empty-state label="surveys.noSurveysFound" src="/assets/illustrations/clipboard-question-mark.png">
            </app-empty-state>
        </app-table>
    </ui-card>
</div>
